import React, { useEffect, useState } from 'react'
import CareerSection from '../careerCard/CareerSection'

const CareerCard = ({selectedTab}) => {
  const [responsiveStatus, setResponsiveStatus] = useState(false);
  // useEffect(() => {
  //   const mediaQueries = {
  //     isSmallMobile: window.matchMedia("(max-width: 400px)"),
  //     isMobile: window.matchMedia("(max-width: 768px)"),
  //     isTablet: window.matchMedia("(max-width: 900px)"),
  //   };
  //   const updateItemsPerPage = () => {
  //     if (mediaQueries.isSmallMobile.matches) {
  //       setResponsiveStatus(true);
  //     } else if (mediaQueries.isMobile.matches) {
  //       setResponsiveStatus(true);
  //     } else if (mediaQueries.isTablet.matches) {
  //       setResponsiveStatus(true);
  //     } else {
  //       setResponsiveStatus(false);
  //     }
  //   };

  //   // Initial run
  //   updateItemsPerPage();

  //   // Event listeners
  //   Object.values(mediaQueries).forEach((mq) =>
  //     mq.addEventListener("change", updateItemsPerPage)
  //   );

  //   // Cleanup
  //   return () => {
  //     Object.values(mediaQueries).forEach((mq) =>
  //       mq.removeEventListener("change", updateItemsPerPage)
  //     );
  //   };
  // }, []);
  
  useEffect(() => {
    const mediaQueries = {
      isSmallMobile: window.matchMedia("(max-width: 400px)"),
      isMobile: window.matchMedia("(max-width: 768px)"),
      isTablet: window.matchMedia("(max-width: 900px)"),
    };

    const updateItemsPerPage = () => {
      if (mediaQueries.isSmallMobile.matches) {
        setResponsiveStatus(true);
      } else if (mediaQueries.isMobile.matches) {
        setResponsiveStatus(true);
      } else if (mediaQueries.isTablet.matches) {
        setResponsiveStatus(true);
      } else {
        setResponsiveStatus(false);
      }
    };

    // Initial run
    updateItemsPerPage();

    // Event listeners
    Object.values(mediaQueries).forEach((mq) =>
      mq.addEventListener("change", updateItemsPerPage)
    );

    // Cleanup
    return () => {
      Object.values(mediaQueries).forEach((mq) =>
        mq.removeEventListener("change", updateItemsPerPage)
      );
    };
  }, []);

  return (
    <>
    <CareerSection responsiveState={responsiveStatus} selectedTab={selectedTab}/>
    </>
  )
}

export default CareerCard